export const COA_GROUP_FORM_FIELD_IDS = {
  GROUP_NAME: 'group-name',
  CATEGORY: 'category'
};
